import React from 'react';
import { FormattedMessage } from 'react-intl';

// constants
import appRoutes from '../../../../../../../../app-routes';
import {
  UserRoles,
  NOTIFICATION_MODULE_MENU_LABEL,
} from '../../../../../../../../constraints';

import useFilters from '../../../../../../../../hooks/useFilters';

// Components
import { ProtectedComponent } from '../../../../../../../Auth/components';
import * as Styled from './styled';

const ArchiveButton = ({ disabled }) => {
  const { filters, navigateWithNewSearchQuery } = useFilters();

  const handleClick = () => {
    navigateWithNewSearchQuery(
      filters,
      appRoutes.NOTIFICATION_TEMPLATE_MANAGE_ARCHIVE,
    );
  };

  return (
    <ProtectedComponent
      roles={[UserRoles.BUSINESS_ADMIN, UserRoles.ADMIN]}
      render={false}
    >
      <Styled.ButtonCol sm={10} md={3}>
        <Styled.FlexEndButton
          outline
          onClick={handleClick}
          fullWidth
          disabled={disabled}
        >
          <FormattedMessage
            id={NOTIFICATION_MODULE_MENU_LABEL.TEMPLATE_ARCHIVE}
            defaultMessage={NOTIFICATION_MODULE_MENU_LABEL.TEMPLATE_ARCHIVE}
          />
        </Styled.FlexEndButton>
      </Styled.ButtonCol>
    </ProtectedComponent>
  );
};

export default ArchiveButton;
